import { SET_DUPLICATE_PARTNER } from '../actions/types';

const meta = (state = {}, action) => {
  switch (action.type) {
    case SET_DUPLICATE_PARTNER:
      return {
        ...state,
        isDuplicatePartner: action.isDuplicatePartner
      };
    default:
      return state;
  }
};

export default meta;
